import React, { Component } from 'react';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Popup, Icon, Checkbox } from 'semantic-ui-react'
import "../Toolbar.css";
import { dispatch } from '@rematch/core';
import { includes } from 'lodash';

let PlaybookArr = [
    { key: 'All', value: '10', order: -1, text: 'All' },
  { key: 'Indesign', value: '0', order: -1, text: 'Indesign' },
  { key: 'Review Request', value: '1', order: -1, text: 'Review Request' },
  { key: 'Approved', value: '2', order: -1, text: 'Approved' },
  { key: 'Published', value: '4', order: -1, text: 'Published' },
  { key: 'Inactive', value: '5', order: -1, text: 'Inactive' },
];
class FilterByStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValues: [], 
            open: false,
        };
    }

    componentWillMount() {
        this.setState({ selectedValues:[this.props.filterByStatus] });
    }
    componentDidUpdate(prevProps){
        if(this.props.filterByStatus !== prevProps.filterByStatus){
            this.setState({ selectedValues:this.props.filterByStatus });
        }
        if(this.props.match.params !== prevProps.match.params){
            if (this.props.match.params && this.props.match.params.status === "knowledgeBank" || this.props.match.params.status === "knowledgeBanks" || this.props.match.params.status === "publicKnowledgeBank"){
                PlaybookArr = PlaybookArr.filter((pb)=>pb.value !== "5")
            }
            else{
                let index = PlaybookArr.findIndex((pb)=>pb.value === "5")
                if(index === -1){
                    PlaybookArr.push({ key: 'Inactive', value: '5', order: -1, text: 'Inactive' })
                }
            }
        }
    }
    handleChangeFilter = (e, { value }) => {
        const { selectedValues } = this.state;
        const index = selectedValues.indexOf(value);
        if(value === "10" && selectedValues.includes("10")){
            this.setState({selectedValues:["4"]})
        }
        else if(value === "10"){
            this.setState({selectedValues: ["0","1","2","3","4","5","10","-1"]});
        }
        else if (index === -1) {
            if(["0", "1", "2", "4", "5","-1"].every(item => [...selectedValues,value].includes(item))){
                this.setState((prevState) => ({
                    selectedValues: [...prevState.selectedValues, value,"10"],
                }));    
            } else {
                this.setState((prevState) => ({
                    selectedValues: [...prevState.selectedValues, value],
                }));
            }
        } else {
             this.state.selectedValues.includes("10")
            let updatedValues = this.state.selectedValues.filter((i)=>i !== value) 
            if (this.state.selectedValues.includes("10")) {
                updatedValues= updatedValues.filter((i)=>i !== "10")
            }                                                                                                                                                                                                                                                                                               
            this.setState({selectedValues:updatedValues})
        }
        setTimeout(async ()=>{
            const payload={ organizationId: this.props.selectedOrganisation.id, status: this.state.selectedValues, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role }
            const {params} = this.props.match
            if(params.baseCategory){
                payload.baseCategory=params.baseCategory
            }
            if(params.category){
                payload.category = params.category
            }
            if(params.subCategory){
                payload.subCategory = params.subCategory
            }
            let scope;
            if (params.status === "knowledgeBank" || params.status === "knowledgeBanks") {
                scope = "Private"
              } else if (params.status === "publicKnowledgeBank") {
                scope = "Public"
              } else {
                scope = null
            }
            payload.scope = scope
            if(params.status && params.status.trim() === 'knowledgeBank') {
                payload.isKnowledgeBank = true;
            }
            await dispatch.lifeCycle.getPacksByStatusArray(payload)
            dispatch.lifeCycle.setSelectedPracticeLibraryData({});
        },100)
    }

    onOpen = () => {
        this.setState({ open: !this.state.open });
    }

    onClose = () => {
        this.setState({ open: false });
    }

    reset = () => {
        this.setState({
            selectedValues: ["-1","0","1","2","3","4","5","10"],
            open: false,
            order: null,
            label: null,
        });
        setTimeout(async ()=>{
            const payload={ organizationId: this.props.selectedOrganisation.id, status: this.state.selectedValues, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role }
            const {params} = this.props.match
            if(params.baseCategory){
                payload.baseCategory=params.baseCategory
            }
            if(params.category){
                payload.category = params.category
            }
            if(params.subCategory){
                payload.subCategory = params.subCategory
            }
            let scope;
            if (params.status === "knowledgeBank" || params.status === "knowledgeBanks") {
                scope = "Private"
              } else if (params.status === "publicKnowledgeBank") {
                scope = "Public"
              } else {
                scope = null
            }
            payload.scope = scope
            if(params.status && params.status.trim() === 'knowledgeBank') {
               payload.isKnowledgeBank = true;
            }
            await dispatch.lifeCycle.getPacksByStatusArray(payload)
            dispatch.lifeCycle.setSelectedPracticeLibraryData({});
        },100)
    }

    render() {
        const integrate = this.props.selectedAccount.integrations && this.props.selectedAccount.integrations.some(int => int.isActive && int.id.id === "openai")
        integrate && !PlaybookArr.some((arr)=> arr.value === "-1") && PlaybookArr.push({ key: 'Generating', value: '-1', order: -1, text: 'Generating' })
        let filterOption = [];
        if (this.props.page === "Playbook") {
            filterOption = PlaybookArr.map(f => {
                if (f.key === 'status' && (this.props.routeParams.status === "playbookLibrary" || this.props.routeParams.status === "knowledgeBank" || this.props.routeParams.status === "publicKnowledgeBank")) {
                    f.disabled = false
                } else if (f.key === 'status' && typeof (this.props.routeParams.status) === "string") {
                    f.disabled = true
                } else {
                    f.disabled = false
                }
                return f
            })
        }

        return (
            <Popup
                trigger={
                    <Button
                        onClick={this.onOpen}
                        className="float-right pad_5"
                        size="mini"
                    >
                        <span style={{
                            minWidth: "110px",
                            display: "inline-block",
                            textAlign: "left",
                        }}>
                            Playbook Status
                        </span>

                        <Icon name='angle down' />
                    </Button>

                }
                on='click'
                position="bottom right"
                open={this.state.open}
                onClose={this.onClose}
                onOpen={this.onOpen}
                hideOnScroll
                className="groupIconList"
            >
                <Popup.Content style={{ width: "140px" }}>
                    <Form>
                        {filterOption && filterOption.map((f, i) => {
                            let removeItemFromList = this.props.routeParams &&
                                this.props.routeParams.status &&
                                this.props.routeParams.status === 'playbookLibrary' && f.value === 'scope' ? false :
                                this.props.routeParams.status === 'knowledgeBank' && f.value === 'scope' ? false :
                                this.props.routeParams.status === 'publicKnowledgeBank' && f.value === 'scope' ? false : true

                            return removeItemFromList && (
                                <React.Fragment key={i}>
                                    <Form.Field
                                        style={{
                                            width: "calc(100% - 30px)",
                                            float: "left",
                                        }}
                                    >
                                        <Checkbox
                                            label={f.text}
                                            name='filterGroup'
                                            value={f.value}
                                            checked={this.state.selectedValues.includes(f.value)}
                                            onChange={this.handleChangeFilter}
                                            order={f.order}
                                            disabled={f.disabled}
                                        />
                                    </Form.Field>
                                </React.Fragment>
                            );
                        })}
                        <Form.Field>
                            <span
                                className="resetIcon"
                                onClick={this.reset}>
                                Reset
                            </span>
                        </Form.Field>
                    </Form>
                </Popup.Content>
            </Popup>
        );
    }
}

export default FilterByStatus;
